import React, { useEffect } from "react";
import { Card, Accordion, Form } from "react-bootstrap";
import AddIndicatorView from "./AddIndicatorView";
import ExitBotIndicatorView from "./exit-bot/ExitBotIndicatorView";
import PriceEntryView from "./price-bot/PriceEntryView";
import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { BotType } from "../../../Const";
import GridEntryView from "./grid-bot/GridEntryView";
import SellBotEntryView from "./sell-bot/SellBotEntryView";
import { useDispatch, useSelector } from "react-redux";
import { DAISY_CHAIN, FIRST_IN_DAISY_CHAIN } from "../../../actions/create-bot-type";
import { getDaisyChainBots } from "../../../actions/bot-action";
import Switch from "react-switch";

const EntryConditionsView = (props) => {
  const { newBot,t } = props;
  const isExitBot = newBot.botType==BotType.exit;
  const priceBot = newBot.botType==BotType.price;
  const daisyChain = newBot.daisyChain;
  const firstInDaisyChain = newBot.firstInDaisyChain;
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const isAdvanced = newBot.botType==BotType.advance;
  const dispatch = useDispatch();
  const changeDaisyChain = (val) => {
    dispatch({
      type: DAISY_CHAIN,
      payload: val,
    });
    if(val==1){
      dispatch(getDaisyChainBots(selectedExchangeId))
    }
  };
  useEffect(() => {
    if(daisyChain==1){
      dispatch(getDaisyChainBots(selectedExchangeId))
    }
  }, [daisyChain]);
  const changeFirstInDaisyChain = (val) => {
    dispatch({
      type: FIRST_IN_DAISY_CHAIN,
      payload: val,
    });
  };
  const getEntryView = ()=>{
    switch (newBot.botType) {
      case BotType.exit:
        return <ExitBotIndicatorView newBot={newBot} isEntry={true} t={t}/>
      case BotType.price :
        return <PriceEntryView newBot={newBot}  isEntry={true} t={t}/>
      case BotType.grid :
        return <GridEntryView newBot={newBot}  isEntry={true} t={t}/>
      case BotType.sell :
        return <SellBotEntryView newBot={newBot}  isEntry={true} t={t}/>
      default:
        return <AddIndicatorView newBot={newBot} isEntry={true} t={t}/>
    }
  }
  return (
    <>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="2">
          <span className="entry-conditions-tour">3. {t("entry-cond")}{" "}</span>
          {<TutorialPopup content={isExitBot?t("entryConditionExitBot-help"):(priceBot?t("entryConditionPriceBot-help"):t("entryCondition-help"))} />}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="2">
          <Card.Body>
          {isAdvanced &&<>
              <Form.Group>
                <div className="label-switch">
                  <Form.Label>Daisy-Chain</Form.Label>
                  <Switch
                      checkedIcon={false}
                      uncheckedIcon={false}
                      checked={daisyChain==1}
                      onChange={(checked) => {
                        changeDaisyChain(checked)
                      }}
                      height={20}
                      width={40}
                      onColor="#05CD99"
                    />
                </div>
              </Form.Group>
              <Form.Group>
              {daisyChain==1 && 
              <div className="label-switch">
                <Form.Label>First in Daisy-Chain</Form.Label>
                <Switch
                    checkedIcon={false}
                    uncheckedIcon={false}
                    checked={firstInDaisyChain==1}
                    onChange={(checked) => {
                      changeFirstInDaisyChain(checked)
                    }}
                    height={20}
                    width={40}
                    onColor="#05CD99"
                  />
              </div>
              }
            </Form.Group></>
            }
            { getEntryView()}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export default EntryConditionsView;
